import { AspectRatio } from '@yme/utils/constants';
export const gridSettings = {
    md: 11,
    lg: 5,
};
export const HIGHLIGHTING_CARD_MAX_ROWS = 5;
export const ASPECT_RATIO_CARD_DEFAULT_PARAMS = {
    sm: AspectRatio.RectangleLevel5,
    md: AspectRatio.RectangleLevel3,
    lg: AspectRatio.RectangleLevel2,
};
